'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useT } from '@/lib/i18n';

function HomeIcon({ active }: { active: boolean }) {
  return (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill={active ? 'currentColor' : 'none'}
      stroke={active ? 'none' : 'currentColor'} strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M3 12l9-9 9 9M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9" />
    </svg>
  );
}

function LeaderboardIcon({ active }: { active: boolean }) {
  return (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill={active ? 'currentColor' : 'none'}
      stroke={active ? 'none' : 'currentColor'} strokeWidth={1.8}>
      {active ? (
        <path d="M3 3h4v18H3V3zm7 6h4v12h-4V9zm7-4h4v16h-4V5z" />
      ) : (
        <>
          <rect x="3" y="3" width="4" height="18" rx="0.5" strokeLinecap="round" strokeLinejoin="round"/>
          <rect x="10" y="9" width="4" height="12" rx="0.5" strokeLinecap="round" strokeLinejoin="round"/>
          <rect x="17" y="5" width="4" height="16" rx="0.5" strokeLinecap="round" strokeLinejoin="round"/>
        </>
      )}
    </svg>
  );
}

function ProfileIcon({ active }: { active: boolean }) {
  return (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill={active ? 'currentColor' : 'none'}
      stroke={active ? 'none' : 'currentColor'} strokeWidth={1.8}>
      {active ? (
        <path d="M12 12a5 5 0 100-10 5 5 0 000 10zm-7 8a7 7 0 0114 0H5z" />
      ) : (
        <>
          <circle cx="12" cy="8" r="4" strokeLinecap="round"/>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
        </>
      )}
    </svg>
  );
}

export function BottomNav() {
  const t = useT();
  const pathname = usePathname();

  const tabs = [
    { href: '/', label: t('nav.home'), Icon: HomeIcon },
    { href: '/leaderboard', label: t('nav.leaderboard'), Icon: LeaderboardIcon },
    { href: '/profile', label: t('nav.profile'), Icon: ProfileIcon },
  ];

  return (
    <nav className="shrink-0 flex flex-col border-t border-sky-200 bg-sky-50/95 backdrop-blur z-20">
      <div className="flex">
        {tabs.map(({ href, label, Icon }) => {
          const active = pathname === href;
          return (
            <Link
              key={href}
              href={href}
              className={`flex-1 flex flex-col items-center justify-center py-1 gap-0.5 transition-colors active:bg-sky-100 ${
                active ? 'text-violet-600' : 'text-slate-400'
              }`}
            >
              <Icon active={active} />
              <span className="text-[10px] font-medium tracking-wide">{label}</span>
            </Link>
          );
        })}
      </div>
      <div className="text-center pb-1">
        <a
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[10px] text-slate-400 hover:text-slate-500 underline underline-offset-2"
        >
          Privacy Policy
        </a>
      </div>
    </nav>
  );
}
